import axios from "axios";
import LocalStorage from "../../localStorage";
import {loggedOut} from "../auth";

export const GET_STATUS_REQUEST = 'GET_STATUS_REQUEST';
export const GET_STATUS_SUCCESS = 'GET_STATUS_SUCCESS';
export const GET_STATUS_FAILURE = 'GET_STATUS_FAILURE';

const localStorageService = LocalStorage.getService();

export const getStatusRequest = () => {
    return {type: GET_STATUS_REQUEST}
};

export const getStatusSuccess = (status = {}) => {
    return {type: GET_STATUS_SUCCESS, status}
};

export const getStatusFailure = (error) => {
    return {type: GET_STATUS_FAILURE, error}
};

export const startGetStatus = () => {
    console.log('Start startGetStatus');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getStatusRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/asset_status/list?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response status search ", response.data);
                    dispatch(getStatusSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if(error.response.status === 401) dispatch(loggedOut());
                dispatch(getStatusFailure(error));
            });
    };
};
